
import WeeConnectPayLogoSrc from "@/assets/WeeConnectPayLogo.svg";
import SignInCover from "@/assets/SignInCover.webp";

export default {
  name: "SplitScreenSignIn",
  props: [],
  setup() {
    // eslint-disable-next-line no-undef
    let authRedirect = weeconnectpayVueData.redirectUrl;

    return {
      WeeConnectPayLogoSrc,
      SignInCover,
      authRedirect
    };
  },
  mounted() {
  },
  computed: {
    weeconnectpayLogoSrc () {
      if (process.env.NODE_ENV === 'development') {
        return WeeConnectPayLogoSrc;
      } else {
          // We import it from WP localize script.
          // eslint-disable-next-line no-undef
          return weeconnectpayVueData.pluginUrl + 'dist' + WeeConnectPayLogoSrc; // the module request
        }
      },
    signInCoverSrc () {
      if (process.env.NODE_ENV === 'development') {
        return SignInCover;
      } else {
        // We import it from WP localize script.
        // eslint-disable-next-line no-undef
        return weeconnectpayVueData.pluginUrl + 'dist' + SignInCover; // the module request
      }
    }
  }
}
// eslint-disable-next-line no-undef
//alert('weeconnectpayVueData test'+weeconnectpayVueData.pluginUrl);
